export default {
  comprobarCampos: function(datos){
    return new Promise((resolve, reject) => {
      const claves = Object.keys(datos);
      let vacios = [];
      for (var i = 0; i < claves.length; i++) {
        if (datos[claves[i]] === "" || parseInt(datos[claves[i]]) === -1)
          vacios.push(claves[i]);
      }
      if (vacios.length === 0) {
        resolve()
      } else {
        reject(vacios);
      }
    })
  },
  nivelAcceso: function(menu, nivel){
    switch (nivel) {
      case "1":
        return (menu.agente);
      case "2":
        return (menu.admin);
      default:
        return (menu.publico);
    }
  }
}
